module.exports = __webpack_public_path__ + "media/images/admin/icons/bar-chart-2-482eeef7b65a401467bbd78bcb9c82da.svg";